import React, {useMemo} from 'react'
import { CheckboxSelector, CheckboxSelectorInner, Avatar } from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../../i18n/useTranslation'
import useUsers from '../../Model/UseUsers'
import FilterBadge from '../../../../common/FilterBadge'

const EducatorsFilter = (props) => {
  const { translate } = useTranslation()
  const { educatorFilters, setEducatorFilters, className, style = {}, useInner = false } = props

  const { data: allUsers } = useUsers({ roles: ['EDUCATOR'], limit: 0 })
  const educators = useMemo(() => allUsers?.docs || [], [allUsers])

  const selectorProps = {
    className,
    setDataFilters: setEducatorFilters,
    direction: 'bottomRight',
    dataFilters: educatorFilters,
    data: educators.map(user => ({
      name: `${user.firstName} ${user.lastName}`,
      id: user.id,
      Component: (
        <Avatar
          name={`${user.firstName} ${user.lastName}`}
          named={false}
          uri={null}
          size='avatar-small'
        />
      )
    })).sort((a, b) => a.name.localeCompare(b.name)),
    typeFilter: 'users',
    strings: {
      viewAll: translate('filters.plans.viewAll'),
      buttonCancel: translate('filters.plans.buttonCancel'),
      buttonApply: translate('filters.plans.buttonApply'),
      search: translate('filters.plans.search')
    },
    style
  }

  return useInner ? (
    <CheckboxSelectorInner
      {...selectorProps}
    />
  ) : (
    <CheckboxSelector {...selectorProps}>
      <FilterBadge
        title={translate('filters.plans.educatorsTitle')}
        options={selectorProps.data}
        selectedIds={educatorFilters}
        onClearFilters={() => setEducatorFilters([])}
      />
    </CheckboxSelector>
  )
}
export default EducatorsFilter
